import React from 'react'
import { Grid, Box } from '@material-ui/core'
import { useStyles } from '../SchoolShow_style'
import FacultyCard from './FacultyCard'

const SchoolCampuses = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <Box>
            <Grid container spacing={2}>
                {school.featured_campuses.map((campus) => {
                    return (
                        <Grid key={`school-campus-${campus.title}`} item xs={12} sm={6} lg={4}>
                            <FacultyCard faculty={campus}/>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>
    )
}

export default SchoolCampuses
